import { combineReducers } from "redux";
import { snackbarReducer } from "./snackbarReducer";
import { PaymentTypeReducer } from "./paymentTypeReducer";
import { userTypeReducer } from "./usertypesReducer";
import { BankReducer } from "./bankReducer";
//import { expensesTypeReducer } from "./expensesTypeReducer";
import {expansesCategoryReducer} from "./expansesCategoryReducer"
import { itemCategoryReducer } from "./itemCategoryReducer";
import { binReducer } from "./binReducer";
import { colourReducer } from "./colourReducer";
import { brandReducer } from "./brandReducer";
import { unitReducer } from "./unitReducer";
import { StockLocationReducer } from "./stockLocationReducer";
import { LastInsertInvoice } from "./lastInsertInvoiceReducer";
import { servicePacks } from "./servicePackReducer";
import { vehicleBrandReducer } from "./vehicleBrandReducer";
import { vehicleTypeReducer } from "./vehicleTypeReducer";
import { pendingUserReducer } from "./pendingUserReducer";
import { activeUserReducer } from "./activeUserReducer";
import { rejectUserReducer } from "./rejectUserReducer";
import { userReducer } from "./userReducer";
import { authReducer } from "./authReducer";
import { defaultLocationReducer } from "./defaultLocationReducer";
import {customerTypeReducer} from "./customerTypeReducer";
import { sizeReducer } from "./sizeReducer";


const reducers = combineReducers({
  itemCategory: itemCategoryReducer,
  unit: unitReducer,
  snackbar: snackbarReducer,
  //expensesType: expensesTypeReducer,
  expansesCategory:expansesCategoryReducer,
  paymentType: PaymentTypeReducer,
  userTypes: userTypeReducer,
  bank: BankReducer,
  bin: binReducer,
  colour: colourReducer,
  brand: brandReducer,
  location: StockLocationReducer,
  lastInsertInvoice: LastInsertInvoice,
  servicePack: servicePacks,
  vehicleBrand: vehicleBrandReducer,
  vehicleType: vehicleTypeReducer,
  activeUser: activeUserReducer,
  rejectUser: rejectUserReducer,
  pendingUser: pendingUserReducer,
  user: userReducer,
  auth: authReducer,
  defaultLocation: defaultLocationReducer,
  customerType:customerTypeReducer,
  size :sizeReducer
});
export default reducers;
